import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const SelectContext = createContext(
{
    ...defaultProperties
});

export default SelectContext ;